const composePage =
  (...hocs) =>
  (Component) =>
    hocs.reduceRight((Comp, hoc) => hoc(Comp), Component);
export default composePage;
